"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.getCss = exports.props = exports.isMobileViewOrDevice = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var inputUtils_1 = require("../../core/inputUtils");
exports.isMobileViewOrDevice = function (isMobileView, deviceType) { return isMobileView || deviceType === 'Smartphone'; };
exports.props = withCompInfo_1.withCompInfo([
    'compData',
    'compProps',
    'skin',
    'isMobileView',
    'hasResponsiveLayout',
    'deviceType',
], function (_a) {
    var compData = _a.compData, compProps = _a.compProps, skin = _a.skin, isMobileView = _a.isMobileView, hasResponsiveLayout = _a.hasResponsiveLayout, deviceType = _a.deviceType;
    var dataPlaceholder = compData.placeholder, minDate = compData.minDate, maxDate = compData.maxDate, allowPastDates = compData.allowPastDates, allowFutureDates = compData.allowFutureDates, disabledDates = compData.disabledDates, disabledDaysOfWeek = compData.disabledDaysOfWeek, label = compData.label;
    var propsPlaceholder = compProps.placeholder, defaultTextType = compProps.defaultTextType, isDisabled = compProps.isDisabled, required = compProps.required, readOnly = compProps.readOnly, dateFormat = compProps.dateFormat, dayToStart = compProps.dayToStart;
    var isMobile = exports.isMobileViewOrDevice(isMobileView, deviceType);
    var normalizedSkin = skin || 'DatePickerDefaultSkin';
    return {
        skin: normalizedSkin,
        label: label,
        placeholder: defaultTextType === 'today'
            ? ''
            : dataPlaceholder || propsPlaceholder || '',
        minDate: minDate,
        maxDate: maxDate,
        allowPastDates: allowPastDates,
        allowFutureDates: allowFutureDates,
        disabledDates: disabledDates,
        disabledDaysOfWeek: disabledDaysOfWeek,
        dateFormat: dateFormat,
        useTodayAsDefaultValue: defaultTextType === 'today',
        weekStartDay: dayToStart === 'Sunday' ? 0 : 1,
        readOnly: readOnly,
        required: required,
        isDisabled: isDisabled,
        isCompactMode: isMobile,
        isResponsive: hasResponsiveLayout,
    };
});
var inputWrapperAlignVar = function (textAlignment) {
    switch (textAlignment) {
        case 'right':
            return {
                '--inputWrapperAlign': 'right',
            };
        default:
            return {
                '--inputWrapperAlign': 'left',
            };
    }
};
var inputPaddingVar = function (textAlignment, textPadding) {
    switch (textAlignment) {
        case 'right':
            return {
                '--inputPadding': "1px " + textPadding + "px 1px 2px",
            };
        default:
            return {
                '--inputPadding': "1px 2px 1px " + textPadding + "px",
            };
    }
};
var calendarButtonPositionVars = function (textAlignment) {
    switch (textAlignment) {
        case 'right':
            return {
                '--calendarButtonLeft': '20px',
                '--calendarButtonRight': 'auto',
            };
        default:
            return {
                '--calendarButtonLeft': 'auto',
                '--calendarButtonRight': '20px',
            };
    }
};
var calendarPositionVars = function (textAlignment) {
    switch (textAlignment) {
        case 'right':
            return {
                '--calendarLeft': 'auto',
                '--calendarRight': '0',
            };
        case 'center':
            return {
                '--calendarLeft': 'calc(50% - 160px)',
                '--calendarRight': 'auto',
            };
        default:
            return {
                '--calendarLeft': '0',
                '--calendarRight': 'auto',
            };
    }
};
var calendarNavRotationVar = function (textAlignment) {
    switch (textAlignment) {
        case 'right':
            return {
                '--calendarNavRotate': '180deg',
            };
        default:
            return {
                '--calendarNavRotate': '0',
            };
    }
};
var calendarNavButtonMarginVars = function (skin, isMobile, textAlignment) {
    var getMargins = function () {
        switch (skin) {
            case 'DatePickerTextBetweenNavSkin': {
                if (isMobile) {
                    return {
                        '--calendarNavYearPrevMargin': [0, -6, -12, 0],
                        '--calendarNavYearNextMargin': [-10, 0, 0, -10],
                        '--calendarNavMonthPrevMargin': [6, -10, -10, 6],
                        '--calendarNavMonthNextMargin': [-10, 54, 54, -10],
                    };
                }
                else {
                    return {
                        '--calendarNavYearPrevMargin': [],
                        '--calendarNavYearNextMargin': [],
                        '--calendarNavMonthPrevMargin': [25, 0, 0, 25],
                        '--calendarNavMonthNextMargin': [0, 20, 20, 0],
                    };
                }
            }
            case 'DatePickerTextYearNavSkin': {
                if (isMobile) {
                    return {
                        '--calendarNavYearPrevMargin': [],
                        '--calendarNavYearNextMargin': [],
                        '--calendarNavMonthPrevMargin': [12, -10, -10, 12],
                        '--calendarNavMonthNextMargin': [-10, 12, 12, -10],
                    };
                }
                else {
                    return {
                        '--calendarNavYearPrevMargin': [],
                        '--calendarNavYearNextMargin': [],
                        '--calendarNavMonthPrevMargin': [10, 0, 0, 10],
                        '--calendarNavMonthNextMargin': [0, 10, 10, 0],
                    };
                }
            }
            default: {
                if (isMobile) {
                    return {
                        '--calendarNavYearPrevMargin': [],
                        '--calendarNavYearNextMargin': [],
                        '--calendarNavMonthPrevMargin': [],
                        '--calendarNavMonthNextMargin': [],
                    };
                }
                else {
                    return {
                        '--calendarNavYearPrevMargin': [],
                        '--calendarNavYearNextMargin': [],
                        '--calendarNavMonthPrevMargin': [5, 0, 5, 0],
                        '--calendarNavMonthNextMargin': [0, 5, 0, 5],
                    };
                }
            }
        }
    };
    var isRtl = textAlignment === 'right';
    return Object.entries(getMargins()).reduce(function (margins, _a) {
        var _b;
        var varName = _a[0], _c = _a[1], left = _c[0], right = _c[1], rtlLeft = _c[2], rtlRight = _c[3];
        return __assign(__assign({}, margins), (_b = {}, _b[varName] = isRtl
            ? "0 " + (rtlRight || 0) + "px 0 " + (rtlLeft || 0) + "px"
            : "0 " + (right || 0) + "px 0 " + (left || 0) + "px", _b));
    }, {});
};
var editorSpecificStyling = function (_a) {
    var compProps = _a.compProps, compLayout = _a.compLayout, isMobileView = _a.isMobileView, hasResponsiveLayout = _a.hasResponsiveLayout, textAlignment = _a.textAlignment;
    if (hasResponsiveLayout) {
        return {
            '--inputWrapperAlignItems': textAlignment === 'right'
                ? 'flex-end'
                : 'flex-start',
            // TODO: Remove '--inputWrapperHeight' prop after TB is GAd
            '--inputWrapperHeight': '100%',
        };
    }
    else {
        return {
            '--inputWrapperHeight': inputUtils_1.getInputHeightInPx({
                compProps: compProps,
                compLayout: compLayout,
                isMobileView: isMobileView,
            }),
            height: 'auto',
        };
    }
};
exports.getCss = function (_a, cssVars) {
    var skin = _a.skin, compData = _a.compData, compProps = _a.compProps, compLayout = _a.compLayout, styleProperties = _a.styleProperties, isMobileView = _a.isMobileView, hasResponsiveLayout = _a.hasResponsiveLayout, deviceType = _a.deviceType;
    var label = compData.label;
    var textAlignment = compProps.textAlignment, textPadding = compProps.textPadding, labelMargin = compProps.labelMargin;
    var isMobile = exports.isMobileViewOrDevice(isMobileView, deviceType);
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, cssVars), { '--textAlign': textAlignment, '--dir': (textAlignment === 'right' ? 'rtl' : 'ltr'), '--labelMarginBottom': labelMargin + "px", '--labelPadding': inputUtils_1.getLabelPadding(compProps) || 'auto', '--requiredIndicationDisplay': inputUtils_1.getRequiredIndicationDisplay(styleProperties) }), inputWrapperAlignVar(textAlignment)), inputPaddingVar(textAlignment, textPadding)), calendarButtonPositionVars(textAlignment)), calendarPositionVars(textAlignment)), calendarNavRotationVar(textAlignment)), { '--calendarMarginTop': isMobile ? '0' : '22px', '--labelDisplay': !label ? 'none' : 'inline-block' }), calendarNavButtonMarginVars(skin, isMobile, textAlignment)), editorSpecificStyling({
        compProps: compProps,
        compLayout: compLayout,
        isMobileView: isMobileView,
        hasResponsiveLayout: hasResponsiveLayout,
        textAlignment: textAlignment,
    }));
};
exports.css = withCompInfo_1.withCompInfo([
    'skin',
    'compData',
    'compProps',
    'compLayout',
    'styleProperties',
    'isMobileView',
    'hasResponsiveLayout',
    'deviceType',
], function (_a, cssVars) {
    var skin = _a.skin, compData = _a.compData, compProps = _a.compProps, compLayout = _a.compLayout, styleProperties = _a.styleProperties, isMobileView = _a.isMobileView, hasResponsiveLayout = _a.hasResponsiveLayout, deviceType = _a.deviceType;
    return exports.getCss({
        skin: skin,
        compData: compData,
        compProps: compProps,
        compLayout: compLayout,
        styleProperties: styleProperties,
        isMobileView: isMobileView,
        hasResponsiveLayout: hasResponsiveLayout,
        deviceType: deviceType,
    }, cssVars);
});
//# sourceMappingURL=DatePicker.js.map